import React from "react"
import {graphql} from 'gatsby'

import Layout from "../components/layout"
import HeroHeader from "../components/HeroHeader";

export default ({data}) => {
  console.log('data', data)
  const post = data.markdownRemark
  return (
    <Layout>
      <HeroHeader
        title={post.frontmatter.title}
        html={post.html}
        image={post.fields.image && post.fields.image.childImageSharp}
      />
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: {slug: {eq: $slug}}) {
      html
      frontmatter {
        title
      }
      fields {
        image {
          childImageSharp {
            fluid(maxWidth: 2000, quality: 100) {
               ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`